import { useRecoilValue } from "recoil";
import { getThousandComma } from "../../../../ApiTS/ApiCommonTS";
import { useApi } from "../../../../hooks/useApi";
import { ICommentInfo } from "../../../../pages/Users/Comment";
import { TotalCount } from "../../../../pages/Users/UserInfo";
import LineBox from "../../../DefaultStyles/LineBox";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import Pagination from "../../../Table/Pagination";
import React, { useState } from "react";
import { authType } from "../../../../pages/Login";
import Blank from "../../../DefaultStyles/Blank";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import LineBtn from "../../../Button/LineBtn";
import CommentModal from "../../Users/UserDetail/CommentModal/CommentModal";
import Loader from "../../../DefaultStyles/Loader";
import { useNavigate } from "react-router-dom";

export default function UnResolvedComment() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [commentModal, setCommentModal] = useState(false);
  const [commentData, setCommentData] = useState<ICommentInfo>({
    commentId: "",
    partyId: "",
    tag: "",
    content: "",
    writeDay: "",
    writer: "",
    name: "",
    nickname: "",
    uid: "",
    servsubsid: 0,
    duedate: "",
    iscomp: 0,
  });

  const {
    response: commentResponse,
    loading: commentLoading,
    fetchData: commentFetchData,
  } = useApi({
    method: "get",
    url: auth?.comment ? `comment?page=${page}&size=5&iscomp=0` : undefined,
  });

  return (
    <>
      <LineBox>
        <TitleWithLine title="미해결 코멘트" />

        <Blank blankHeight={24} />

        <Table
          tableMinWidth={520}
          tableHeadData={["UID", "PID", "태그(구분)", "해결 기한", "상세"]}
        >
          <>
            {commentResponse?.data?.items?.map((c: ICommentInfo, i: number) => (
              <TableBody key={i}>
                <TableBodyItem
                  clickable
                  onClick={() => navigate(`/users/info/${c?.uid}`)}
                >
                  {c?.uid}
                </TableBodyItem>
                <TableBodyItem
                  clickable={c?.partyId !== "0" ? true : false}
                  onClick={() => {
                    if (c?.partyId !== "0") {
                      navigate(`/party/info/${c?.partyId}`);
                    }
                  }}
                >
                  {c?.partyId === "0" ? "-" : c?.partyId ?? "-"}
                </TableBodyItem>
                <TableBodyItem>{c?.tag}</TableBodyItem>
                <TableBodyItem>{c?.duedate ?? "-"}</TableBodyItem>
                <TableBodyItem>
                  <LineBtn
                    btnText="상세"
                    btnClickEvent={() => {
                      setCommentData(c);
                      setCommentModal(true);
                    }}
                  />
                </TableBodyItem>
              </TableBody>
            ))}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
            totalPage={
              commentResponse?.status === 200
                ? commentResponse?.data?.totalPage
                : 1
            }
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              commentResponse?.status === 200
                ? +commentResponse?.data?.totalCount
                : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {commentLoading && <Loader />}

      {/* 코멘트 상세 모달 */}
      {commentModal && (
        <CommentModal
          closeEvent={() => setCommentModal(false)}
          confirmEvent={() =>
            commentFetchData({
              method: "get",
              url: auth?.comment
                ? `comment?page=${page}&size=5&iscomp=0`
                : undefined,
            })
          }
          commentData={commentData}
          type="view"
        />
      )}
    </>
  );
}
